import _setToStringTag from "../internals/set-to-string-tag";
var setToStringTag = _setToStringTag;

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, "Math", true);
export default {};